import { CreditCardVerificationDialog } from "@/components/billing/CreditCardVerificationDialog";
import { VerifyCardContext } from "@/components/QueryClientProvider";
import { useToast } from "@/components/podkit/toasts/use-toast";
import { useReloadBillingInfo } from "@/queries/organization-queries";
import { useCallback, useContext, type FC } from "react";

export const VerifyCardModal: FC = () => {
    const { isVerificationRequired, setVerificationRequired, onCloseCallback, clearCallback } =
        useContext(VerifyCardContext);
    const { reload: reloadBillingInfo } = useReloadBillingInfo();
    const { toast } = useToast();

    const handleVisibilityChange = useCallback(
        (open: boolean) => {
            if (!open) {
                setVerificationRequired(false);
                if (onCloseCallback) {
                    onCloseCallback();
                    clearCallback();
                }
            }
        },
        [setVerificationRequired, onCloseCallback, clearCallback],
    );

    const handleVerificationSuccess = useCallback(() => {
        reloadBillingInfo();
        // Card verification is a prerequisite for platform use, so this only triggers for Free-tier users.
        toast({
            title: "Thank you!",
            description:
                "We've added $10 in OCUs to your account. Upgrade to Core to get an additional $100 in free credits.",
        });
        handleVisibilityChange(false);
    }, [reloadBillingInfo, toast, handleVisibilityChange]);

    return (
        <CreditCardVerificationDialog
            open={isVerificationRequired}
            onOpenChange={handleVisibilityChange}
            onVerificationSuccess={handleVerificationSuccess}
        />
    );
};
